// ** React Imports
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";

// ** Redux Imports
import { Provider } from "react-redux";
import { store } from "./redux/storeConfig/store";
import "react-list-editable/lib/react-list-editable.css";
// ** Toast & ThemeColors Context
import { ToastContainer } from "react-toastify";
import { ThemeContext } from "./utility/context/ThemeColors";
import "sweetalert2/src/sweetalert2.scss";
// ** Spinner (Splash Screen)
import Loader from "./component/loader/Loader";

// ** Ripple Button
import "./@core/components/ripple-button";

// ** PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-jsx.min";

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";

// ** React Toastify
import "@styles/react/libs/toastify/toastify.scss";
import "react-toastify/dist/ReactToastify.css";
// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";
import "semantic-ui-css/semantic.min.css";

// ** Service Worker
import * as serviceWorker from "./serviceWorker";
import "./index.scss";
import { Switch } from "react-router-dom";
import { ConfigProvider } from "antd";
import { cognitoAuthConfig } from "./configs/oidcConfig";
import { AuthProvider } from "react-oidc-context";
import AuthBridge from "./component/AuthBridge/AuthBridge";
import { AuthPermissionProvider } from "./utility/authPermissionsProvider";

// ** Lazy load app
const LazyApp = lazy(() => import("./App"));
ReactDOM.render(
  <AuthProvider {...cognitoAuthConfig}>
    <Provider store={store}>
      <Suspense fallback={<Loader />}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#7355F7",
              colorPrimaryBorder: "#7355F7",
            },
            components: {
              DatePicker: {
                activeBorderColor: "#4096ff",
                colorPrimaryBorder: "#4096ff",
                activeShadow: "none",
              },
              Button: {
                linkHoverBg: "#10045A",
                defaultBg: "#10045A",
                defaultBorderColor: "#10045A",
                defaultColor: "#ffffff",
                defaultHoverBorderColor: "#27197e",
                defaultHoverColor: "#ffffff",
                defaultHoverBg: "#27197e",
                defaultActiveBorderColor: "#27197e",
                defaultActiveColor: "#ffffff",
                defaultActiveBg: "#27197e",
                textTextColor: "#10045A",
                textTextHoverColor: "#10045A",
              },
            },
          }}
        >
          <AuthBridge />
          <ThemeContext>
            <AuthPermissionProvider>
              <LazyApp />
            </AuthPermissionProvider>
            <Loader />
            <ToastContainer newestOnTop />
          </ThemeContext>
        </ConfigProvider>
      </Suspense>
    </Provider>,
  </AuthProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
